import { RootState } from "@/store/store";
import { resourceExplorerChartSettingsSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/chart/settings/resourceExplorerChartSettingsSelector";

export const billingExplorerCurrentBudgetIdSelector = (state: RootState) => {
  return resourceExplorerChartSettingsSelector(state)?.selected_budget_id;
};
